import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IAppTypesApiResponse } from 'src/app/shared/models/app.interface';
import { CommonService } from '../../../app/shared/services/common.service';
import { environment } from '../../../environments/environment';
import { PendingCommentsResponse } from 'src/app/shared/models/security-finding-comment.model';
import { GetLiveSecurityFindingsResponseDto } from './open-production-findings/models/getLiveSecurityFindingsResponseDto';

@Injectable({
  providedIn: 'root',
})
export class SecurityService extends CommonService {
  idSecurityFinding: string;
  readonly baseUrl = environment.urls.apiBaseUrl;

  public getFindingsComments() {
    return this.httpClient.get<PendingCommentsResponse>(
      this.baseUrl + `security_findings/pending_comments`,
      {
        withCredentials: true,
      },
    );
  }

  public getSecurityFindingsDetail(appUuid, findingId) {
    return this.httpClient.get<any>(
      this.baseUrl + `apps/${appUuid}/issues/${findingId}?status=open`,
    );
  }

  public getLiveSecurityFindings() {
    return this.httpClient.get<GetLiveSecurityFindingsResponseDto>(
      `${this.baseUrl}live_security_findings`,
      {
        withCredentials: true,
      },
    );
  }
}
